import type { TenantsJSON } from "interfaces/shared.types";
import { getTenantSettings } from "./getTenantSettings";

export const getCategoryClient = (tenantsJSON?: TenantsJSON) => {
  const clientName = getTenantSettings(tenantsJSON)?.client_name;
  if (!clientName) {
    return console.error(
      "No client_name defined for current tenant (from tenants.json)",
    );
  }

  return getTenantSettings(tenantsJSON)?.client_name;
};

export const getCategoryLanguage = (tenantsJSON?: TenantsJSON) => {
  const categoryLanguage = getTenantSettings(tenantsJSON)?.default_locale;
  if (!categoryLanguage) {
    return console.error(
      "No default_locale defined for current tenant (from tenants.json)",
    );
  }
  return categoryLanguage.split("-")[0];
};

export const getBasePath = (tenantsJSON?: TenantsJSON) => {
  const basePath = getTenantSettings(tenantsJSON)?.base_path;
  if (!basePath) {
    return console.error(
      "No base_path defined for current tenant (from tenants.json)",
    );
  }
  return basePath;
};

export const getRubyTenantVersion = (tenantsJSON?: TenantsJSON) => {
  const rubyTenantVersion = getTenantSettings(tenantsJSON)?.ruby_tenant_version;
  if (!rubyTenantVersion) {
    return console.error(
      "No ruby_tenant_version defined for current tenant (from tenants.json)",
    );
  }
  return rubyTenantVersion;
};
